import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectSubThreads } from 'store/chat/services/getProjectSubthreads.service';

export const getProjectSubthreadsThunk = createAsyncThunk(
  'chat/getProjectSubthreads',
  async ({ projectId }, { getState }) => {
    const response = await getProjectSubThreads(projectId);
    return response;
  }
);
